import { createUseStyles } from "react-jss";
import wrapperSkin from "../skin/datagrid/wrapper.skin";
import { useSelector } from "react-redux";
import { selectColumnWidth } from "../../../selectors/column-width";
import classNames from "classnames";

const useStyles = createUseStyles(wrapperSkin);
const selectOpenedRows = (state) => state.masterDetail.openedRows;

const DatagridWrapper = ({ children }) => {
  const columnWidth = useSelector(selectColumnWidth);
  const openedRows = useSelector(selectOpenedRows);
  const classes = useStyles();

  const hasOpenedRows = openedRows.length > 0;
  const hasColumnsWithCustomWidth = Object.keys(columnWidth).length > 0;

  return (
    <table
      className={classNames({
        [classes["wrapper-no-hover"]]: hasOpenedRows,
        [classes["wrapper-with-hover"]]: !hasOpenedRows,
        [classes["wrapper-auto-width"]]: hasColumnsWithCustomWidth,
        [classes["wrapper-full-width"]]: !hasColumnsWithCustomWidth,
      })}
    >
      {children}
    </table>
  );
};

export default DatagridWrapper;
